// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"3611571d8a1da4573139","1125":"9ef4638075f4074ce9de","1455":"b7cec7e5b241ba05fe27","3635":"855a7b4d365247e0e2fb","9985":"24d3ffbad6e10db7b6a6"}[chunkId] + ".chunk.js";
};